import React from "react";
import ButtonGroups, { BGItem } from "components/ButtonGroups";
import TextInput from "components/TextInput";
import { REFERENCE_UNITS } from "features/MappingEditor/consts";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { epdEditorStore } from "../EPDEditorStore";

const ReferenceUnit = () => {
  const { t, i18n } = useTranslation();
  const isEng = i18n.language === "en";

  const onChangeReferenceUnit = (item: BGItem | undefined) => {
    epdEditorStore.onChangeData("reference_unit", item?.id);
  };

  const currentRefUnit = REFERENCE_UNITS.find(
    (item) => item.id === epdEditorStore.data.reference_unit
  );

  return (
    <div className="pt-6">
      <div className="text-base font-semibold mb-3">
        {t("productEditor.referenceValues")}
      </div>
      <ButtonGroups
        items={REFERENCE_UNITS}
        onChange={onChangeReferenceUnit}
        current={currentRefUnit}
        containerClassName="w-full mb-3"
        label={t("components.reference_unit")}
        confirmTitle={t("productEditor.confirmModalTitle")}
        confirmButtonTitle={t("productEditor.changeReferenceUnit")}
        confirmDescriptionMesage={t("productEditor.changeReferenceUnitDesc")}
        helper={t("EPDEditor.referenceUnitHelper")}
        required
        optionClsssName="h-[36px]"
        size="middle"
      />
      <div className="flex gap-6 w-full">
        <TextInput
          labelName={t("EPDEditor.referenceFactor")}
          placeholder={t("EPDEditor.pleaseEnter")}
          containerClass="w-full"
          type="number"
          handleChange={(value) =>
            epdEditorStore.onChangeData("reference_factor", value)
          }
          value={epdEditorStore.data.reference_factor}
          helper={t("EPDEditor.referenceFactorHelper")}
          required
        />
        <TextInput
          labelName={t("EPDEditor.mass_conversion_factor")}
          placeholder={t("EPDEditor.pleaseEnter")}
          unit={`${isEng ? currentRefUnit?.name : currentRefUnit?.name_de}/kg`}
          containerClass="w-full"
          type="number"
          helper={t("EPDEditor.mass_conversion_factor_helper", {
            unit: isEng ? currentRefUnit?.name : currentRefUnit?.name_de,
          })}
          handleChange={(value) =>
            epdEditorStore.onChangeData("mass_conversion_factor", value)
          }
          value={epdEditorStore.data.mass_conversion_factor}
          min={0}
        />
      </div>
      <div className="flex gap-6 w-full">
        <TextInput
          labelName={t("productEditor.lengthWidth")}
          placeholder={t("EPDEditor.pleaseEnter")}
          helper={t("EPDEditor.lengthWeightHelper")}
          unit="kg/m"
          containerClass="w-full"
          type="number"
          handleChange={(value) =>
            epdEditorStore.onChangeData("mass_value_m", value)
          }
          value={epdEditorStore.data.mass_value_m}
          min={0}
        />
        <TextInput
          labelName={t("productEditor.surfaceWeight")}
          placeholder={t("EPDEditor.pleaseEnter")}
          helper={t("EPDEditor.surfaceWeightHelper")}
          noMargin
          unit="kg/m²"
          containerClass="w-full"
          type="number"
          handleChange={(value) =>
            epdEditorStore.onChangeData("mass_value_m2", value)
          }
          value={epdEditorStore.data.mass_value_m2}
          min={0}
        />
      </div>
      <div className="flex gap-6 w-full">
        <TextInput
          labelName={t("productEditor.rawDensity")}
          placeholder={t("EPDEditor.pleaseEnter")}
          helper={t("EPDEditor.rawDensityHelper")}
          noMargin
          unit="kg/m³"
          containerClass="w-full"
          type="number"
          handleChange={(value) =>
            epdEditorStore.onChangeData("mass_value_m3", value)
          }
          value={epdEditorStore.data.mass_value_m3}
          min={0}
        />
      </div>
    </div>
  );
};

export default observer(ReferenceUnit);
